import { IService } from '../types/global';
import { IAddServiceToCart, IAddServiceToCartProps } from '../types/add-service-to-cart';

export const handleCompleteAddService = ({
  refetchCart = () => null,
  onMutationComplete = () => null,
}: IAddServiceToCart) => () => {
  onMutationComplete();
  refetchCart();
};

export const handleAddServiceToCart = ({ addServiceQuery }: IAddServiceToCartProps) => (
  cartId: string,
  lineId: string,
  services: Array<IService>
) => {
  if (cartId && lineId && services?.length > 0) {
    addServiceQuery({
      variables: { cartId, lineId, services },
    });
  }
};
